import { Config as ConfigIcon, Forms as FormsIcon } from '@clearkit/icons';
import { CKTab, CKTabList, CKTabs } from 'clearkit';
import { useHistory } from 'react-router-dom';

import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import Tile from '~/images/Tiles/Forms.svg';
import { configurationNameForType } from '~/lib/configuration';
import paths from '~/lib/paths';
import { connectorLocations } from '~/lib/segmentAnalytics';

import Configuration from './Configuration';
import Mappings from './Mappings';

const TABS = [
  {
    key: 'configuration',
    title: 'Configuration',
    icon: ConfigIcon,
    component: Configuration,
    index: 0,
  },
  {
    key: 'mappings',
    title: 'Form Field Mappings',
    icon: FormsIcon,
    component: Mappings,
    index: 1,
  },
];

function FormConfiguration({ integration, selectedTab }) {
  const currentTab = selectedTab || 'configuration';

  const currentTabObject = TABS.find((t) => t.key === currentTab);
  const FormComponent = currentTabObject.component;
  const history = useHistory();

  return (
    <ConnectorLayout
      breadcrumb={[
        {
          title: 'Forms',
          path: paths.forms(),
        },
      ]}
      connectorLocation={connectorLocations.forms}
      integration={integration}
      subtitle={`Improve conversion rates on ${configurationNameForType(
        integration,
      )} forms`}
      tabs={
        <CKTabs
          className="h-full"
          index={currentTabObject.index}
          isBordered
          onChange={(index) => {
            const newTab = TABS[index];

            history.push(`/forms/${integration}/${newTab.key}`);
          }}
        >
          <CKTabList aria-label="Forms Configuration Tabs">
            {Object.values(TABS).map((tab) => (
              <CKTab icon={<tab.icon />} key={tab.key} label={tab.title}>
                {tab.title}
              </CKTab>
            ))}
          </CKTabList>
        </CKTabs>
      }
      tile={<Tile />}
    >
      {() => (
        <div className="h-full px-10 py-10 bg-gray-50">
          <FormComponent integration={integration} />
        </div>
      )}
    </ConnectorLayout>
  );
}

export default FormConfiguration;
